import React, { createContext, useContext, useState } from 'react';

const DashboardContext = createContext();

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
};

export const DashboardProvider = ({ children }) => {
  const [selectedPeriod, setSelectedPeriod] = useState('all');
  const [selectedCustomRange, setSelectedCustomRange] = useState({ start: '', end: '' });
  const [customRangeApplied, setCustomRangeApplied] = useState(false);

  // Reset custom range when period changes
  const handlePeriodChange = (newPeriod) => {
    setSelectedPeriod(newPeriod);
    if (newPeriod !== 'custom') {
      setSelectedCustomRange({ start: '', end: '' });
      setCustomRangeApplied(false);
    }
  };

  const value = {
    selectedPeriod,
    setSelectedPeriod: handlePeriodChange,
    selectedCustomRange,
    setSelectedCustomRange,
    customRangeApplied,
    setCustomRangeApplied,
  };

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};
